import "./css/products.css";
import { useParams } from "react-router-dom";
import { MdDownload } from "react-icons/md";
import TabNavItem from "../components/TabNavItem";
import TabContent from "../components/TabContent";
import "../components/Tabs.css";
import React, { useState } from "react";
import p1 from "./img/레디프리산.png";
import p2 from "./img/이노프리.jpg";
import p3 from "./img/이노쿨산_.jpg";
import p4 from "./img/제로프리.jpg";

import Acecide from "./img/Acecide.png";
import EndoRapid from "./img/EndoRapid.png";

import SubHeader from "../components/subHeader2";
import i18next from "../config/lang/i18next";
const options = [
  {id:"m1",title:i18next.t("m1")},
  {id:"m2",title:i18next.t("m2")},
  {id:"m3",title:i18next.t("m3")},
  {id:"m4",title:i18next.t("m4")},
  {id:"m5",title:i18next.t("m5")},
];

const Products = () => {
    let { id } = useParams();
  
  const [activeTab, setActiveTab] = useState(id);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(id);
  const toggling = () => setIsOpen(!isOpen);
  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
    console.log(selectedOption);
  };
  const pdfDownload = () => {
    // using Java Script method to get PDF file
    fetch('SamplePDF.pdf').then(response => {
        response.blob().then(blob => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = 'SamplePDF.pdf';
            alink.click();
        })
    })
  }
  return (
    <div className="wrapper">
      <SubHeader />
      <div className="section_title">
        <h1 className="headerText"></h1>
      </div>
      <div className="Tabs2">
        <ul className="nav">
          <TabNavItem
            title={i18next.t("m1")}
            id="m1"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          {/*<TabNavItem
            title="이노프리솔루션액 1리터"
            id="이노프리솔루션액 1리터"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />*/}
          <TabNavItem
            title={i18next.t("m2")}
            id="m2"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <TabNavItem
            title={i18next.t("m3")}
            id="m3"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

        <TabNavItem
            title={i18next.t("m4")}
            id="m4"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          <TabNavItem
            title={i18next.t("m5")}
            id="m5"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </ul>
        <div className="dropdown_container">
 
 <div>
   <div className="">
     <select value={selectedOption} onChange={(e)=>{console.log(e.target.value);setSelectedOption(e.target.value);
       setActiveTab(e.target.value);
     }}>
     {options.map((option) => (
      
         <option
           value={option.id}                    
         >
           {option.title}
         </option>
     ))}
     </select>
   </div>
 </div>
</div>

        <div className="outlet">
          <TabContent id="m1" activeTab={activeTab}>
            <div className="pd_row">
              <img src={p1} alt="ex1"></img>
            </div>

            <div className="pDesc">
            <div className="btns" style={{width:"auto", justifyContent:"center"}}>
            <a href="/catalog/레디프리.pdf" target="_blank" download>
                  <button style={{background:"#ff7d8f", border:"none", color:"#fff"}}>{i18next.t("download")}
                    <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>

              <table>
                <tbody>
                <tr>
                  <th colSpan={2}>{i18next.t("m1_")}</th>
                </tr>
                <tr>
                  <th>{i18next.t("m1-1")}</th>
                  <td>{i18next.t("m1-2")}</td>
                </tr>
             
                <tr>
                  <th>{i18next.t("m1-3")}</th>
                  <td>{i18next.t("m1-4")}</td>
                </tr>
                <tr>
                  <th>{i18next.t("m1-5")}</th>
                  <td>{i18next.t("m1-6")}</td>
                </tr>

                <tr>
                  <th>{i18next.t("m1-7")}</th>
                  <td>
                    {" "}
                    {i18next.t("m1-8")}
                  </td>
                </tr>

                <tr>
                  <th>{i18next.t("m1-9")}</th>
                  <td>
                    {" "}
                    {i18next.t("m1-10")}<br></br>
                    {i18next.t("m1-11")}<br></br>
                    {i18next.t("m1-12")}<br></br>
                    {i18next.t("m1-13")}
                  </td>
                </tr>

                <tr>
                  <th>{i18next.t("m1-14")}</th>
                  <td>
                  {i18next.t("m1-15")}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </TabContent>
          <TabContent id="m2" activeTab={activeTab}>
            <div className="pd_row">
              <img src={p3} alt="ex1"></img>
            </div>

            <div className="pDesc">
            <div className="btns" style={{width:"auto", justifyContent:"center"}}>
            <a href="/catalog/이노쿨산.pdf" target="_blank" download>
                <button style={{background:"#ff7d8f", border:"none", color:"#fff"}}>{i18next.t("download")}
                <MdDownload style={{marginLeft:"5px"}}/>
                  </button>

                </a>
              </div>
         
              <table>
                <tbody>
                <tr>
                  <th colSpan={2}>{i18next.t("m2_")}</th>
                </tr>
                <tr>
                  <th>{i18next.t("m2-1")}</th>
                  <td>{i18next.t("m2-2")}</td>
                </tr>
         
                <tr>
                  <th>{i18next.t("m2-3")}</th>
                  <td>{i18next.t("m2-4")}</td>
                </tr>
                <tr>
                  <th>{i18next.t("m2-5")}</th>
                  <td>{i18next.t("m2-6")}</td>
                </tr>
                <tr>
                  <th>{i18next.t("m2-7")}</th>
                  <td>{i18next.t("m2-8")}</td>
                </tr>

                <tr>
                  <th>{i18next.t("m2-9")}</th>
                  <td>{i18next.t("m2-10")}</td>
                </tr>
                <tr>
                  <th>{i18next.t("m2-11")}</th>
                  <td>
                    {" "}
                    {i18next.t("m2-12")}<br></br>
                    {i18next.t("m2-13")}<br></br>
                    {i18next.t("m2-14")}<br></br>
                    {i18next.t("m2-15")}<br></br>
                    {i18next.t("m2-16")}
                  </td>
                </tr>

                <tr>
                  <th>{i18next.t("m2-17")}</th>
                  <td>
                  {i18next.t("m2-18")}
                  <br></br>{i18next.t("m2-19")}
                  <br></br>{i18next.t("m2-20")}
                  <br></br>{i18next.t("m2-21")}
             
                  </td>
                </tr>

             
                </tbody>
              </table>
            </div>
          </TabContent>
          <TabContent id="m3" activeTab={activeTab}>
            <div className="pd_row">
              <img src={p4} alt="ex1"></img>
            </div>

            <div className="pDesc">
            <div className="btns" style={{width:"auto", justifyContent:"center"}}>
            <a href="/catalog/제로프리.pdf" target="_blank" download>
                <button style={{background:"#ff7d8f", border:"none", color:"#fff"}}>{i18next.t("download")}
                <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>

              <table>
                <tbody>
                <tr>
                  <th colSpan={2}>{i18next.t("m3_")}</th>
                </tr>
                <tr>
                  <th>{i18next.t("m3-1")}</th>
                  <td>{i18next.t("m3-2")}</td>
                </tr>
         
                <tr>
                  <th>{i18next.t("m3-3")}</th>
                  <td>{i18next.t("m3-4")}</td>
                </tr>
                <tr>
                  <th>{i18next.t("m3-5")}</th>
                  <td>{i18next.t("m3-6")}</td>
                </tr>

                <tr>
                  <th>{i18next.t("m3-7")}</th>
                  <td>
                    {" "}
                    {i18next.t("m3-8")}<br></br>
                    {i18next.t("m3-9")}<br></br>
                    {i18next.t("m3-10")}
                  </td>
                </tr>

                <tr>
                  <th>{i18next.t("m3-11")}</th>
                  <td>
                  {i18next.t("m3-12")}
                  <br></br>{i18next.t("m3-13")}
                  <br></br>{i18next.t("m3-14")}
                  <br></br>{i18next.t("m3-15")}
                  <br></br>{i18next.t("m3-16")}
                  <br></br>{i18next.t("m3-17")}
                  </td>
                </tr>

                <tr>
                  <th>{i18next.t("m3-18")}</th>
                  <td>
                    <li>{i18next.t("m3-19")}</li>
                    <li>{i18next.t("m3-20")}</li>
                    <li>{i18next.t("m3-21")}</li>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </TabContent>

          <TabContent id="m4" activeTab={activeTab}>
            <div className="pd_row">
              <img src={Acecide} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns" style={{width:"auto", justifyContent:"center"}}>
                <a href="/catalog/Acecide.pdf" target="_blank" download>
                <button style={{background:"#ff7d8f", border:"none", color:"#fff"}}>{i18next.t("download")}
                <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>

                        
                         <div className="">
                                
            <div className="device_desc">

  <ul class="colorcircle_list">
    <li class="colorcircle_item">{i18next.t("m4-1")}</li>
    <li class="colorcircle_item">{i18next.t("m4-2")}</li>
    <li class="colorcircle_item">{i18next.t("m4-3")}</li>
    <li class="colorcircle_item">{i18next.t("m4-4")}</li>
    <li class="colorcircle_item">{i18next.t("m4-5")}</li>
    <li class="colorcircle_item">{i18next.t("m4-6")}</li>
    <li class="colorcircle_item">{i18next.t("m4-7")}</li>


  </ul>
        
             </div>
           </div>
            </div>
          </TabContent>


          <TabContent id="m5" activeTab={activeTab}>
            <div className="pd_row">
              <img src={EndoRapid} alt="ex1"></img>
            </div>

            <div className="pDesc">
              <div className="btns" style={{width:"auto", justifyContent:"center"}}>
                <a href="/catalog/EndoRapid.pdf" target="_blank" download>
                <button style={{background:"#ff7d8f", border:"none", color:"#fff"}}>{i18next.t("download")}
                <MdDownload style={{marginLeft:"5px"}}/>
                  </button>
                </a>
              </div>

                        
                         <div className="">
                                
            <div className="device_desc">
             <h3 style={{color:"#f54"}}>High detergency</h3>
              <p>{i18next.t("m5-1")}</p>
             <h3 style={{color:"#f54"}}>Ideal for the automated cleaning process</h3>
              <p>{i18next.t("m5-2")}</p>
             <h3 style={{color:"#f54"}}>Safe for use with OLYMPUS endoscopes</h3>
              <p>{i18next.t("m5-3")}</p>
           
             <h3 style={{color:"#f54"}}>Easy-to-use design
             </h3>
              <p>{i18next.t("m5-4")}</p>
           
             </div>
           </div>
            </div>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default Products;
